import React from "react";
import {FormattedMessage} from 'react-intl';
import {VideoContentType, VideoContentSortOrder} from "@modes/video";



export interface NavigationConfiguration {
  navigation_type: NavigationType,
  content_id: string
  url: string | null
  category_id: string | null
  tag_id: string | null
  person_id: string | null
  year: string | null
  content_type: VideoContentType,
  sort_order: VideoContentSortOrder,
}


export interface NavigationButton {
  title: string,
}

export const enum NavigationType {
  "NONE" = "none",
  "GET_BY_FILTER" = "get_by_filter",
  "EXTERNAL_ROUTE" = "external_route",
  "INTERNAL_ROUTE" = "internal_route",
  "CONTENT" = "content",
  "CATEGORY" = "category",
  "PERSON" = "person",
  "TAG" = "tag",
  "PERSONS" = "persons",
  "TAGS" = "tags",
  "CATEGORIES" = "categories",
}


export const NavigationTypeOptions = [{
  value: NavigationType.NONE,
  label: <FormattedMessage id="app.none" defaultMessage={`None`}/>
}, {
  value: NavigationType.CONTENT,
  label: <FormattedMessage id="app.specific_content" defaultMessage={`Specific Content`}/>
}, {
  value: NavigationType.GET_BY_FILTER,
  label: <FormattedMessage id="app.get_by_filter" defaultMessage={`Get By Filter`}/>
}, {
  value: NavigationType.EXTERNAL_ROUTE,
  label: <FormattedMessage id="app.external_route" defaultMessage={`External Route`}/>
}, {
  value: NavigationType.INTERNAL_ROUTE,
  label: <FormattedMessage id="app.internal_route" defaultMessage={`Internal Route`}/>
}, {
  value: NavigationType.CATEGORY,
  label: <FormattedMessage id="app.specific_category" defaultMessage={`Specific category`}/>
}, {
  value: NavigationType.TAG,
  label: <FormattedMessage id="app.specific_tag" defaultMessage={`Specific tag`}/>
}, {
  value: NavigationType.PERSON,
  label: <FormattedMessage id="app.specific_person" defaultMessage={`Specific person`}/>
},{
  value: NavigationType.TAGS,
  label: <FormattedMessage id="app.tags" defaultMessage={`Tags`}/>
},{
  value: NavigationType.CATEGORIES,
  label: <FormattedMessage id="app.categories" defaultMessage={`Categories`}/>
},{
  value: NavigationType.PERSONS,
  label: <FormattedMessage id="app.people" defaultMessage={`People`}/>
}];
